import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
export default function ContactCTA({
  eyebrow = "Get in Touch",
  headline = "Let's build something amazing.",
  description = "Ready to start your project? Tell us where you're headed and we'll map the path to get there — design, development, and launch in record time.",
  buttonLabel = "Start Your Project",
  onClick,
}) {
  return (
    <section
      id="contact"
      className="relative isolate w-full overflow-hidden bg-black py-28 md:py-36 text-white"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 [background:radial-gradient(60%_60%_at_50%_0%,rgba(122,92,255,0.22),transparent_60%),radial-gradient(50%_50%_at_50%_100%,rgba(122,149,181,0.15),transparent_60%)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.06] [background-image:linear-gradient(to_right,white_1px,transparent_1px),linear-gradient(to_bottom,white_1px,transparent_1px)] [background-size:48px_48px] [mask-image:radial-gradient(circle_at_center,black,transparent_75%)]"
      />

      <div className="relative mx-auto flex max-w-5xl flex-col items-center px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1 text-xs font-medium text-white/70 backdrop-blur"
        >
          <Sparkles className="h-3.5 w-3.5 text-[#47b0ff]" aria-hidden />
          {eyebrow}
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="mt-2 py-4 text-[2.25rem] sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05] text-white [text-shadow:0_0_48px_rgba(255,255,255,0.12)]"
        >
          {headline}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-4 max-w-2xl text-base md:text-lg text-white/60"
        >
          {description}
        </motion.p>

        <motion.button
          type="button"
          onClick={onClick}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="group relative mt-10 inline-flex items-center gap-2 overflow-hidden rounded-full border border-white/15 bg-white/[0.04] px-7 py-3.5 text-sm md:text-base font-semibold text-white backdrop-blur transition-colors hover:border-white/30"
        >
          <span
            aria-hidden
            className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 [background:linear-gradient(90deg,rgba(122,92,255,0.35),rgba(122,149,181,0.35))]"
          />
          <span className="relative z-10">{buttonLabel}</span>
          <ArrowRight
            className="relative z-10 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
            aria-hidden
          />
        </motion.button>
      </div>
    </section>
  );
}
